export default class BasicController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    const showMoreGames = app.portal?.hideMoreGames !== true && app.fullVersion !== true;
    const showSuggestions = app.portal?.hideSuggestions !== true;
    const showReportBug = app.portal?.hideReportBug !== true;
    const model = {
      showMoreGames: showMoreGames,
      showSuggestions: showSuggestions,
      showReportBug: showReportBug
    };
    app.populate(pageId, model);
    app.swapPage(pageId);
  }
}